import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";

const FloatingActions = ({ phone }) => (
  <Box sx={{ position: "fixed", bottom: 28, right: 24, zIndex: 1100, display: "flex", flexDirection: "column", gap: 1.5 }}>
    <Tooltip title="Chat on WhatsApp" placement="left">
      <IconButton
        component="a"
        href={`https://wa.me/91${phone}?text=Hello%2C%20I%20am%20interested%20in%20St%20Lord%27s%20School.`}
        target="_blank"
        sx={{ width: 52, height: 52, backgroundColor: "#25D366", border: "2.5px solid #1B1F3B", boxShadow: "4px 4px 0 #1B1F3B", color: "#fff", animation: "bounce 2.5s ease-in-out infinite", "&:hover": { transform: "translate(-2px,-2px)", boxShadow: "6px 6px 0 #1B1F3B" } }}
      >
        <ChatRoundedIcon sx={{ fontSize: 26 }} />
      </IconButton>
    </Tooltip>
    <Tooltip title="Call Us" placement="left">
      <IconButton
        component="a"
        href={`tel:+91${phone}`}
        sx={{ width: 52, height: 52, backgroundColor: "#06D6A0", border: "2.5px solid #1B1F3B", boxShadow: "4px 4px 0 #1B1F3B", color: "#1B1F3B", animation: "pulse 2s ease-in-out infinite", "&:hover": { transform: "translate(-2px,-2px)", boxShadow: "6px 6px 0 #1B1F3B" } }}
      >
        <PhoneRoundedIcon sx={{ fontSize: 26 }} />
      </IconButton>
    </Tooltip>
  </Box>
);

export default FloatingActions;
